export async function downloadFileFromStream(
  fileName: string | undefined,
  contentStreamReference: { arrayBuffer: () => Promise<ArrayBuffer> }
): Promise<void> {
  const arrayBuffer = await contentStreamReference.arrayBuffer();
  const blob = new Blob([arrayBuffer]);
  const url = URL.createObjectURL(blob);

  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.download = fileName ?? '';
  anchorElement.click();
  anchorElement.remove();

  URL.revokeObjectURL(url);
}

/**
 * Waits until the element matching selector exists, then calls callback.
 */
export function loadElemIfReady(selector: string, callback: (elem: HTMLElement) => void): void {
    const elem = document.querySelector<HTMLElement>(selector);
    if (elem) {
        callback(elem);
    } else {
        setTimeout(() => loadElemIfReady(selector, callback), 50);
    }
}

export function blurElement(elementId: string): void {
  const element = document.getElementById(elementId) as HTMLElement | null;
  element?.blur();
}

export function scrollToTop(anchorClass?: string): void {
  try {
    const className = anchorClass ?? 'rz-layout';
    const elem = document.getElementsByClassName(className)[0] as HTMLElement | undefined;
    if (elem) elem.scrollTop = 0;
  } catch (ex) {
    console.error(ex);
  }
}

export function loadPortraitVideo(): void {
  const video = document.getElementById('videoTagPortraitId') as HTMLVideoElement | null;
  video?.load();
}

export function loadLandscapeVideo(): void {
  const video = document.getElementById('videoTagLandscapeId') as HTMLVideoElement | null;
  video?.load();
}